import React, { useCallback, useEffect, useState } from "react";
import { FileText, RefreshCw } from "lucide-react";
import { studioApi, errMsg } from "../../lib/studioApi";
import { DmReplyKit } from "./DmReplyKit";

export const GuidesPanel = ({ notify }) => {
  const [guides, setGuides] = useState([]);
  const load = useCallback(() => studioApi.guides().then(setGuides).catch((e) => notify(errMsg(e), "destructive")), [notify]);
  useEffect(() => { load(); }, [load]);
  const building = guides.some((g) => g.status === "building");
  useEffect(() => {
    if (!building) return undefined;
    const t = setInterval(load, 6000);
    return () => clearInterval(t);
  }, [building, load]);
  const rebuild = async (g) => {
    await studioApi.rebuildGuide(g.slug);
    notify(`Rewriting the ${g.region} guide…`);
    load();
  };

  return (
    <details className="rounded-2xl border border-zinc-800 bg-zinc-950/60 p-4 group" data-testid="guides-panel">
      <summary className="cursor-pointer flex items-center gap-2 text-sm font-black uppercase tracking-widest" data-testid="guides-panel-toggle">
        <FileText className="w-4 h-4 text-[#BEFF38]" /> Niggle guides · DM replies
        <span className="ml-auto text-[10px] font-mono text-zinc-500">{guides.filter((g) => g.status === "ready").length}/{guides.length} ready</span>
      </summary>
      <p className="text-xs text-zinc-400 mt-3">When someone replies with a keyword, tap Copy DM and paste it into their Instagram DM. The link opens a free PDF guide built from the app's real swaps.</p>
      <div className="grid md:grid-cols-2 gap-2 mt-3">
        {guides.map((g) => (
          <div key={g.slug} className="flex items-center gap-2">
            <div className="flex-1 min-w-0"><DmReplyKit region={g.region} status={g.status} notify={notify} /></div>
            <button onClick={() => rebuild(g)} disabled={g.status === "building"} aria-label={`Rewrite ${g.region} guide`} data-testid={`guide-rebuild-${g.slug}`} className="h-8 w-8 grid place-items-center rounded-full text-zinc-500 hover:text-white disabled:opacity-30">
              <RefreshCw className={`w-3.5 h-3.5 ${g.status === "building" ? "animate-spin" : ""}`} />
            </button>
          </div>
        ))}
      </div>
    </details>
  );
};
